export default "__VITE_ASSET__CNEXrhDS__"